import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FooterAcknowledge from "../components/FooterAcknowledge";

function ContactUs() {
  return (
    <div>
      <Contact />
      <FooterAcknowledge />
      <Footer />
    </div>
  );
}

export default ContactUs;
